import _extends from "@babel/runtime/helpers/extends";
import {
/* eslint-disable-next-line no-restricted-imports */
useAnalyticsEvents as useAKAnalyticsEvents,
/* eslint-disable-next-line no-restricted-imports */
withAnalyticsEvents as withAKAnalyticsEvents } from '@atlaskit/analytics-next';
import React from 'react';
// for class based components
export function withAnalytics(BaseComponent) {
  function HOCComponent(props) {
    const fireAnalyticsEvent = prop => {
      return (payload, channel = 'marketplace') => prop.createAnalyticsEvent({ ...payload
      }).fire(channel);
    };

    return /*#__PURE__*/React.createElement(BaseComponent, _extends({}, props, {
      fireAnalyticsEvent: fireAnalyticsEvent(props)
    }));
  }

  return withAKAnalyticsEvents()(HOCComponent);
} // for functional components

export const useAnalyticsEvents = () => {
  const {
    createAnalyticsEvent
  } = useAKAnalyticsEvents();

  const handleAnalyticsEvent = (payload, channel = 'marketplace') => {
    createAnalyticsEvent({ ...payload
    }).fire(channel);
  };

  return handleAnalyticsEvent;
};